import { render, staticRenderFns } from "./IconTypeformDate.vue?vue&type=template&id=c71199d8&"
import script from "./IconTypeformDate.vue?vue&type=script&lang=ts&"
export * from "./IconTypeformDate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports